import React from 'react';
import { Doughnut } from 'react-chartjs-2';

import { useRequiredChartPlugins } from '../plugins/usePlugins.ts';
import { ChartContainer } from '../styled.ts';
import type { ChartJSOrUndefined, ChartProps } from '../types.ts';

type ChartType = 'doughnut';

interface DoughnutChartProps extends ChartProps<ChartType> {
  resizeable?: boolean;
}

const DoughnutChart = React.forwardRef<ChartJSOrUndefined<ChartType>, DoughnutChartProps>(function DoughnutChart(props, ref) {
  const { 'data-testid': testId, resizeable, ...chartProps } = props;
  useRequiredChartPlugins<ChartType>(chartProps.options);

  return (
    <ChartContainer
      data-testid={testId}
      $resizeable={resizeable}
      style={{
        height: chartProps.height ? `${chartProps.height}px` : undefined,
        width: chartProps.width ? `${chartProps.width}px` : undefined,
      }}>
      <Doughnut ref={ref} {...chartProps} />
    </ChartContainer>
  );
});

export default DoughnutChart;
